import requestAxios from '@/utils/request'

export function getListProfessorApi (params) {
  return requestAxios.get('enter-score/professor', {params})
}



// WEBPACK FOOTER //
// ./src/api/enter-score/professor.js